export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value)
}

export function sortByKeys(object: Record<string, any>): Record<string, any> {
  return Object.keys(object)
    .sort()
    .reduce((obj, key) => {
      obj[key] = object[key]
      return obj
    }, {})
}

/**
 * Take an array or items and group them into an object based on the value of a given property.
 * @param items the items to be processed
 * @param field the field to be used for grouping
 * Example:
 *   input: [{foo: 'a', bar: 10}, {foo: 'a', bar: 20}, {foo: 'b', bar: 30}, {foo: 'c', bar: 40}]
 *   output: {a: [{foo: 'a', bar: 10}, {foo: 'a', bar: 20}], b: [{foo: 'b', bar: 30}], c: [{foo: 'c', bar: 30}]}
 */
export function groupByField(
  items: Record<string, any>[],
  field: string
): Record<string, Record<string, any>> {
  const result = {}
  for (const item of items) {
    if (!(item[field] in result)) result[item[field]] = []
    result[item[field]].push(item)
  }
  return result
}
